import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchAgencyDocumentSummaryFailure,
  fetchAgencyDocumentSummaryRequest,
  fetchAgencyDocumentSummarySuccess,
} from 'redux/slice/agency-onbording/AgencyDocumentSummary.slice';
import { agencyOnboarding } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

const fetchAgencyDocumentSummaryApi = async (agencyId: string) => {
  const response = await HTTPClient.GetRequest(
    agencyOnboarding.GET_AGENCY_DOCUMENTS_SUMMARY(agencyId)
  );
  return response.data;
};

function* fetchAgencyDocumentSummarySaga(
  action: any
): Generator<any, void, any> {
  try {
    const documentSummaryResponse = yield call(
      fetchAgencyDocumentSummaryApi,
      action.payload
    );
    if (documentSummaryResponse) {
      yield put(fetchAgencyDocumentSummarySuccess(documentSummaryResponse));
    }
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || 'Failed to fetch summary';
    yield put(fetchAgencyDocumentSummaryFailure(errorMessage));
  }
}

export function* watchAgencyDocumentSummarySaga() {
  yield takeLatest(
    fetchAgencyDocumentSummaryRequest.type,
    fetchAgencyDocumentSummarySaga
  );
}
